import api from './api';

export default {
  getReferrerList() {
    return new Promise((resolve, reject) => {
      api
        .get('business/referrers')
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  verifyEmail(email) {
    return new Promise((resolve, reject) => {
      api
        .get('user', {
          params: {
            columns: 'id',
            filters: {
              where: [['email', '=', email]]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  verifyBusiness(businessRef) {
    return new Promise((resolve, reject) => {
      api
        .get('business', {
          params: {
            columns: 'id',
            filters: {
              whereHas: [
                {
                  relation: 'businessType',
                  filters: {
                    where: [['name', '=', 'customer']]
                  }
                }
              ],
              where: [['business_ref', '=', businessRef]]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  checkForReferral(commercialName, email) {
    return new Promise((resolve, reject) => {
      api
        .get('referral', {
          params: {
            columns: 'id',
            filters: {
              where: [
                ['name', '=', commercialName],
                ['email', '=', email]
              ]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getExperianList(businessName, postcode, ltdCompany) {
    return new Promise((resolve, reject) => {
      api
        .post('business/lookup', {
          businessName,
          postcode,
          ltdCompany
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  registerBusiness(details) {
    return new Promise((resolve, reject) => {
      api
        .post('register', { details })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  updateRegistration(updateData, referral) {
    return new Promise((resolve, reject) => {
      api
        .put(`register/${updateData.id}`, {
          updateData,
          referral
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response.data.error));
    });
  }
};
